// Figma "auto-awesome" sparkle mark, reused in the header, empty state, and
// choice screen. Ported verbatim from the drawer's <ng-template #sparkle>.
export function Sparkle({ class: className }: { class?: string }) {
  return (
    <svg
      class={className ?? 'aj-sparkle'}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12.6667 6L13.5001 4.1667L15.3334 3.3333L13.5001 2.5L12.6667 0.6667L11.8334 2.5L10.0001 3.3333L11.8334 4.1667L12.6667 6Z" />
      <path d="M12.6667 10L11.8334 11.8333L10.0001 12.6667L11.8334 13.5L12.6667 15.3333L13.5001 13.5L15.3334 12.6667L13.5001 11.8333L12.6667 10Z" />
      <path d="M7.6667 6.3333L6.0001 2.6667L4.3334 6.3333L0.6667 8L4.3334 9.6667L6.0001 13.3333L7.6667 9.6667L11.3334 8L7.6667 6.3333ZM6.6601 8.66L6.0001 10.1133L5.3401 8.66L3.8867 8L5.3401 7.34L6.0001 5.8867L6.6601 7.34L8.1134 8L6.6601 8.66Z" />
    </svg>
  );
}

/** Inline close icon — replaces the drawer's <i class="fas fa-times">, whose
 * CSS lives in the host document and can't reach into the shadow root. */
export function CloseIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M1 1L13 13M13 1L1 13"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
}

/** Corner brackets pointing outward — "expand to fullscreen". */
export function ExpandIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M9 1H13V5M13 1L8 6M5 13H1V9M1 13L6 8"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

/** Corner brackets pointing inward — "restore from fullscreen". */
export function CollapseIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M13 5H9V1M8 6L13 1M1 9H5V13M6 8L1 13"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

/** Speech-bubble mark for the floating launcher — reads as "this opens a
 * chat" at a glance, unlike the sparkle (which is really an "AI" mark, used
 * elsewhere for the header/empty-state where the surrounding text already
 * says what it is). */
export function ChatIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2" y="4" width="20" height="14" rx="4" />
      <path d="M8 18L8 22L13 18Z" />
    </svg>
  );
}
